import React from 'react';
import { Box, Container, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Chip, Alert, CircularProgress, Typography } from '@mui/material';
import { Badge as BadgeIcon } from '@mui/icons-material';
import MainLayout from '../../../components/layout/MainLayout';
import { staffApi, Staff } from '../api';
import { formatDateDDMMYYYY } from '../../../utils/dateFormatter';

const statusColor = (status?: string) => {
  const code = String(status || '').toUpperCase();
  if (code === 'ACTIVE') return 'success';
  if (code === 'RESIGNED') return 'warning';
  if (code === 'INACTIVE') return 'default';
  return 'info';
};

const ResignedPage: React.FC = () => {
  const [resigned, setResigned] = React.useState<Staff[]>([]);
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState('');

  React.useEffect(() => {
    loadResigned();
  }, []);

  const loadResigned = async () => {
    setLoading(true);
    setError('');
    try {
      const data = await staffApi.listResigned();
      setResigned(data);
    } catch (err: any) {
      setError(err.message || 'Failed to load resigned staff');
    } finally {
      setLoading(false);
    }
  };

  return (
    <MainLayout>
      <Container maxWidth="lg" sx={{ py: 3 }}>
        <Stack spacing={2} sx={{ mb: 3 }}>
          <Box>
            <h2 style={{ margin: 0 }}>Resigned Staff</h2>
            <p style={{ margin: '4px 0 0 0', color: '#666', fontSize: '14px' }}>Historical records of resigned employees</p>
          </Box>
        </Stack>

        {error ? <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert> : null}

        <TableContainer component={Paper}>
          {loading ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
              <CircularProgress />
            </Box>
          ) : resigned.length === 0 ? (
            <Box sx={{ p: 2, textAlign: 'center' }}>No resigned staff records</Box>
          ) : (
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>Employee Code</TableCell>
                  <TableCell>Name</TableCell>
                  <TableCell>Department</TableCell>
                  <TableCell>Designation</TableCell>
                  <TableCell>Relieving Date</TableCell>
                  <TableCell>Status</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {resigned.map((row) => (
                  <TableRow key={row.id} hover>
                    <TableCell>{row.employeeCode}</TableCell>
                    <TableCell>{row.firstName} {row.lastName}</TableCell>
                    <TableCell>{row.department?.name || '-'}</TableCell>
                    <TableCell>{row.designation?.name || '-'}</TableCell>
                    <TableCell>{row.relievingDate ? formatDateDDMMYYYY(row.relievingDate) : '-'}</TableCell>
                    <TableCell><Chip size="small" label={row.status} color={statusColor(row.status) as any} /></TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          )}
        </TableContainer>
      </Container>
    </MainLayout>
  );
};

export default ResignedPage;
